var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945724 6.31693C0.753773 6.50888 0.749855 6.84969 0.949641 7.04947C1.15334 7.24926 1.49416 7.24534 1.68219 7.05731L4.00127 4.73823L6.31644 7.05339C6.5123 7.24926 6.8492 7.24926 7.04898 7.04947C7.24877 6.84577 7.24877 6.51279 7.0529 6.31693L4.73774 4.00176L7.0529 1.68268C7.24877 1.48682 7.25269 1.14992 7.04898 0.950137C6.8492 0.750352 6.5123 0.750352 6.31644 0.94622L4.00127 3.26138L1.68219 0.94622C1.49416 0.754269 1.14943 0.746434 0.949641 0.950137C0.749855 1.14992 0.753773 1.49465 0.945724 1.68268L3.26089 4.00176L0.945724 6.31693Z",
    fill: "#3C3C43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close_small.545cf2e7d2d3638f0f360c19ca3518af.svg";
export { ForwardRef as ReactComponent };